import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { projectHeading } from "./data/PorjectData";
import { projectHeadingAbabic } from "./data/PorjectDataArabic";
import { blogHeading, blogsSlidesData, categoryLabels } from "./data/blogsData";
import {
  blogHeadingArabic,
  blogsSlidesDataArabic,
  categoryLabelsArabic,
} from "./data/blogsDataArabic";
import { testimonialContent, testimonials } from "./data/testimonailsData";
import {
  testimonialContentArabic,
  testimonialsArabic,
} from "./data/testimonailDataArabic";
import {
  DevelopmentServicesContent,
  DevelopmentServicesData,
} from "./data/developmentServicesTabsData";
import {
  DevelopmentServicesContentArabic,
  DevelopmentServicesDataArabic,
} from "./data/developmentServicesTabsDataArabic";
import {
  bannerContent,
  CoverTheStack,
  TypesOfBuildData,
  WebAppservicesRoadMap,
  webDevPageIndustriesSection,
  WebServicesFaqData,
  WebServicesHighvaluesData,
  WhoWeServeData,
  WhyChooseBitsclanData,
} from "./data/web-app-services-data";
import {
  bannerContentArabic,
  CoverTheStackArabic,
  TypesOfBuildDataArabic,
  WebAppservicesRoadMapArabic,
  webDevPageIndustriesSectionArabic,
  WebServicesFaqDataArabic,
  WebServicesHighvaluesDataArabic,
  WhoWeServeDataArabic,
  WhyChooseBitsclanDataArabic,
} from "./data/web-app-services-data-arabic";
import { engagementModelContent } from "./data/engagementModelContent";
import { engagementModelContentArabic } from "./data/engagementModelContentArabic";
import tabData, {
  BannerDataEn,
  staticHeading,
  hireContactIndustriesSectionContentEn,
  pioneerChangeSectionContent,
  slidesData,
  industriesContent,
} from "./data/industryData";
import tabDataArabic, {
  staticHeadingArabic,
  hireContactIndustriesSectionContentAr,
  pioneerChangeSectionContentArabic,
  similerBannerDataAr,
  slidesDataArabic,
  industriesContentArabic,
} from "./data/industryDataArabic";
import { lifeAtBitsclanData } from "./data/lifeAtBitsclanData";
import { lifeAtBitsclanArabicData } from "./data/lifeAtBitsclanArabicData";
import {
  CustomDevelopmentIndustriesHeading,
  customDevelopmentPageRoadMapData,
  CustomDevelopmentPageServicesData,
  customDevPageBannerData,
  customDevPageCoverTheStack,
  CustomDevPageFaqData,
  customDevPageHighvaluesData,
  CustomDevPageTypesOfBuildData,
  CustomDevPageWhoWeServeData,
  CustomDevPageWhyChooseBitsclanData,
} from "./data/custom-development-data";
import {
  CustomDevelopmentIndustriesHeadingArabic,
  customDevelopmentPageRoadMapDataArabic,
  CustomDevelopmentPageServicesDataArabic,
  customDevPageBannerDataArabic,
  customDevPageCoverTheStackArabic,
  CustomDevPageFaqDataArabic,
  customDevPageHighvaluesDataArabic,
  CustomDevPageTypesOfBuildDataArabic,
  CustomDevPageWhoWeServeDataArabic,
  CustomDevPageWhyChooseBitsclanDataArabic,
} from "./data/custom-development-data-arabic";
import {
  DevOpsBannerContent,
  devOpsCoverTheStack,
  DevOpsFaqData,
  devOpsPageHireUsData,
  devOpsProcessStepsData,
  devOpsRoadMapContent,
  devOpsServices,
  devOpsSolutionsData,
  PionerChangeHeadings,
  WhyChoseUsData,
} from "./data/dev-ops-data";
import {
  DevOpsBannerContentArabic,
  devOpsCoverTheStackArabic,
  DevOpsFaqDataArabic,
  devOpsPageHireUsDataArabic,
  devOpsProcessStepsDataArabic,
  devOpsRoadMapContentArabic,
  devOpsServicesArabic,
  devOpsSolutionsDataArabic,
  PionerChangeHeadingsArabic,
  WhyChoseUsDataArabic,
} from "./data/dev-ops-data-arabic";
import {
  AnalyticsHighvaluesData,
  AnalyticsWhoWeServeData,
  AnalyticsWhyChooseBitsclanData,
  DataAnalyticsBannerContent,
  dataAnalyticsCoverTheStackData,
  DataAnalyticsTypesOfBuildSection,
  DataAndAnalyticsServicesData,
  faqData,
  industriesHeading,
} from "./data/dataAnalyticsPageData";
import {
  AnalyticsHighvaluesDataArabic,
  AnalyticsWhoWeServeDataArabic,
  AnalyticsWhyChooseBitsclanDataArabic,
  DataAnalyticsBannerContentArabic,
  dataAnalyticsCoverTheStackDataArabic,
  DataAnalyticsTypesOfBuildSectionArabic,
  DataAndAnalyticsServicesDataArabic,
  faqDataArabic,
  industriesHeadingArabic,
} from "./data/dataAnalyticsPageDataArabic";
import { analyticsDataArabic } from "./data/analayticsSolutionDataArabic";
import { analyticsData } from "./data/analayticsSolutionData";
import {
  EngagementModelPageBannerDataEn,
  engagmentModelPageData,
} from "./data/engagementModelPageData";
import {
  EngagementModelPageBannerDataAr,
  engagmentModelPageDataArabic,
} from "./data/engagementModelPageDataArabic";
import megaMenuContent from "./data/megaMenuData";
import megaMenuContentArabic from "./data/megaMenuDataArabic";
import footerContent from "./data/footerData";
import footerContentArabic from "./data/footerDataArabic";
import contactSectionComponentArabic from "./data/contactSectionComponentDataArabic";
import contactSectionComponent from "./data/contactSectionComponentData";
import {
  solutionsData,
  mainBannerImg,
  servicesData,
  steps,
  facts,
  hiringDetails,
  tabs,
  tabItems,
  techCombinations,
  schemaData,
  hireRubyAndRailsPageContent,
  hirefaqData, // Import the main content object
} from "./data/hire-ruby-and-rails.data";

// Import Arabic data
import {
  solutionsDataArabic,
  mainBannerImgArabic,
  servicesDataArabic,
  stepsArabic,
  factsArabic,
  hiringDetailsArabic,
  tabsArabic,
  tabItemsArabic,
  techCombinationsArabic,
  schemaDataArabic,
  hireRubyAndRailsPageContentArabic,
  hireFaqDataArabic, // Import the Arabic main content object
} from "./data/hire-ruby-and-rails-data-arabic"; // Assuming your Arabic data is in the same file or a parallel one

import { WebServicesIndustryTabsData } from "./data/industries-tab-section-data";
import { WebServicesIndustryTabsDataArabic } from "./data/industries-tab-section-data-arabic";
import { roadMapCommonData } from "./data/road-map-common-data";
import { roadMapCommonDataArabic } from "./data/road-map-common-data-arabic";
import {
  aiDevBannerContent,
  aiDevCoverTheStack,
  aiDevelopmentBoxContent,
  AiDevelopmentServicesData,
  AiDevPageFaqData,
  AIDevPageSolutionsSection,
  AIDevRoadmapContent,
  AIDevWhyUsContent,
  aiPowerSectionContent,
  IndustriesSectionContent,
} from "./data/ai-development-data";
import {
  aiDevBannerContentArabic,
  aiDevCoverTheStackArabic,
  aiDevelopmentBoxContentArabic,
  AiDevelopmentServicesDataArabic,
  AiDevPageFaqDataArabic,
  AIDevPageSolutionsSectionArabic,
  AIDevRoadmapContentArabic,
  AIDevWhyUsContentArabic,
  aiPowerSectionContentArabic,
  IndustriesSectionContentArabic,
} from "./data/ai-development-data-arabic";
import {
  frequentlyAskedQuestionData,
  mobileAppCoverTheStack,
  mobileAppDevelopmetServices,
  mobileAppHighvaluesData,
  mobileAppIndustriesHeading,
  mobileAppPageBanner,
  mobileAppRoadMapHeadings,
  mobileAppTypesOfBuildData,
  mobileAppWhoWeServeData,
  mobileAppWhyChoseUs,
} from "./data/mobile-app-development-data";
import {
  frequentlyAskedQuestionDataArabic,
  mobileAppCoverTheStackArabic,
  mobileAppDevelopmetServicesArabic,
  mobileAppHighvaluesDataArabic,
  mobileAppIndustriesHeadingArabic,
  mobileAppPageBannerArabic,
  mobileAppRoadMapHeadingsArabic,
  mobileAppTypesOfBuildDataArabic,
  mobileAppWhoWeServeDataArabic,
  mobileAppWhyChoseUsArabic,
} from "./data/mobile-app-development-data-arabic";
import {
  SaqDevelopmentServicesDataArabic,
  sqaCoverTheStackArabic,
  sqaFaqDataArabic,
  sqaHighvaluesDataArabic,
  sqaIndustriesHeadingArabic,
  sqaPageBannerArabic,
  sqaRoadMapDataArabic,
  sqaTypesOfBuildDataArabic,
  sqaWhoWeServeDataArabic,
  sqaWhyChooseBitsclanDataArabic,
} from "./data/software-quality-assurence-data-arabic";
import {
  SaqDevelopmentServicesData,
  sqaCoverTheStack,
  sqaFaqData,
  sqaHighvaluesData,
  sqaIndustriesHeading,
  sqaPageBanner,
  sqaRoadMapData,
  sqaTypesOfBuildData,
  sqaWhoWeServeData,
  sqaWhyChooseBitsclanData,
} from "./data/software-quality-assurence-data";
import {
  BlockchainBannerContent,
  BlockchainCoverTheStack,
  BlockchainDevelopmentServicesData,
  BlockchainFaqData,
  BlockchainHighvaluesData,
  BlockchainIndustriesHeading,
  BlockchainProcessStepsData,
  BlockchainRoadMapData,
  BlockchainWhoWeServeData,
  BlockchainWhyChooseBitsclanData,
} from "./data/blockchainPageData";
import {
  BlockchainBannerContentArabic,
  BlockchainCoverTheStackArabic,
  BlockchainDevelopmentServicesDataArabic,
  BlockchainFaqDataArabic,
  BlockchainHighvaluesDataArabic,
  BlockchainIndustriesHeadingArabic,
  BlockchainProcessStepsDataArabic,
  BlockchainRoadMapDataArabic,
  BlockchainWhoWeServeDataArabic,
  BlockchainWhyChooseBitsclanDataArabic,
} from "./data/blockchainPageDataArabic";

import { KsaHomeData } from "./data/ksaHomeData";
import { KsaHomeDataArabic } from "./data/ksaHomeDataArabic";
import { hireDjangoPageData } from "./data/hire-django-data";
import { hireDjangoPageDataArabic } from "./data/hire-django-data-arabic";

import {
  CybersecurityBannerContent,
  cyberSecurityCoverTheStack,
  cyberSecurityDevelopmentServicesData,
  cyberSecurityFaqData,
  cyberSecurityHighvaluesData,
  cyberSecurityIndustriesHeading,
  CybersecurityRoadmapData,
  cyberSecurityTypesOfBuildData,
  cyberSecurityWhoWeServeData,
  cyberSecurityWhyChooseBitsclanData,
} from "./data/cyber-security-data";
import {
  CybersecurityBannerContentArabic,
  cyberSecurityCoverTheStackArabic,
  cyberSecurityDevelopmentServicesDataArabic,
  cyberSecurityFaqDataArabic,
  cyberSecurityHighvaluesDataArabic,
  cyberSecurityIndustriesHeadingArabic,
  CybersecurityRoadmapDataArabic,
  cyberSecurityTypesOfBuildDataArabic,
  cyberSecurityWhoWeServeDataArabic,
  cyberSecurityWhyChooseBitsclanDataArabic,
} from "./data/cyber-security-data-arabic";
import {
  HireAngularBannerDataAr,
  hireAngularCoverTheStackAr,
  hireAngularEnagementModelAr,
  HireAngularFactsDataAr,
  HireAngularFaqDataAr,
  HireAngularServicesDataAr,
  HireAngularSolutionsDataAr,
  HireAngularStepsAr,
  hireAppContentAr,
  mainBannerImgAngularArabic,
  techCombinationsAr,
} from "./data/hireAngularPageDataArabic";
import {
  HireAngularBannerDataEn,
  hireAngularCoverTheStackEn,
  hireAngularEnagementModelEn,
  HireAngularFactsDataEn,
  HireAngularFaqDataEn,
  HireAngularServicesDataEn,
  HireAngularSolutionsDataEn,
  HireAngularStepsEn,
  hireAppContentEn,
  mainBannerImgAngular,
  techCombinationsEn,
} from "./data/hireAngularPagedata";
import { hireGoLangContentArabic } from "./data/hire-goLang-data-arabic";
import { hireGoLangContent } from "./data/hire-goLang-data";
import { hireFlutterPageContent } from "./data/hireFlutterPageData";
import { hireFlutterPageContentArabic } from "./data/hireFlutterPageDataArabic";
import { hireMernStackPageContent } from "./data/hireMernstackPageData";
import { hireMernStackPageContentArabic } from "./data/hireMernstackPageDataArabic";
import { hireJavascriptPageContent } from "./data/hire-javascript-data";
import { hireJavascriptPageContentArabic } from "./data/hire-javascript-data-arabic";
import { hireAndroidPageContentArabic } from "./data/hireAndroidPageDataArabic";
import { hireAndroidDeveloper } from "./data/hireAndroidPageData";
import { hireNodePageContent } from "./data/hireNodejsPageData";
import { hireNodePageContentArabic } from "./data/hireNodejsPageDataArabic";

// COMBINED REACT IMPORTS
import {
  hireAppIdesContentEn,
  hireReactBannerContentEn,
  hireReactCombinationsEn,
  hireReactCoverTheStackEn,
  hireReactExpertFactsEn,
  hireReactPageEngagementModelsEn,
  hireReactServicesDataEn,
  hireReactSolutionsDataEn,
  hireReactStepsEn,
  mainBannerImgReact,
  reactFaqContentEn,
} from "./data/hire-reactjs-data";

import {
  hireAppIdesContentAr,
  hireReactBannerContentAr,
  hireReactCombinationsAr,
  hireReactCoverTheStackAr,
  hireReactExpertFactsAr,
  hireReactPageEngagementModelsAr,
  hireReactServicesDataAr,
  hireReactSolutionsDataAr,
  hireReactStepsAr,
  mainBannerImgAr,
  mainBannerImgReactAr,
  reactFaqContentAr,
} from "./data/hire-reactjs-data-arabic";

import {
  coverTheStackPythonAr,
  factIdeaAr,
  hirePythonBannerContentAr,
  hirePythonCombinationsAr,
  hirePythonExpertiseAr,
  hirePythonFactsDataAr,
  hirePythonFaqDataAr,
  hirePythonPageContentAr,
  hirePythonPerformanceAr,
  hirePythonStepsAr,
  mainBannerImgPythonArabic,
} from "./data/hire-python-data-arabic";
import {
  coverTheStackPythonEn,
  factIdeaEn,
  hirePythonBannerContentEn,
  hirePythonCombinationsEn,
  hirePythonExpertiseEn,
  hirePythonFactsDataEn,
  hirePythonFaqDataEn,
  hirePythonPageContentEn,
  hirePythonPerformanceEn,
  hirePythonStepsEn,
  mainBannerImgPython,
} from "./data/hire-python-data";
import { cookiesObj, privacyPolicyObj } from "./data/modalData";
import {
  cookiesObjArabic,
  privacyPolicyObjArabic,
} from "./data/modalDataArabic";

import { portfolioPageData } from "./data/portfolioPageData";
import { portfolioPageDataArabic } from "./data/portfolioPageDataArabic";
import {
  caseStudiesContentEn,
  caseStudyBannerEn,
} from "./data/case-studies-data";
import {
  caseStudiesContentAr,
  caseStudyBannerAr,
} from "./data/case-studies-data-arabic";
import { aiContactData } from "./data/aiContactSectionData";
import { aiContactDataArabic } from "./data/aiContactSectionDataArabic";
import { metaTitlesEn } from "./data/meta-titles-en";
import { metaTitlesAr } from "./data/meta-titles-ar";
import { privacyPolicyContentAr } from "./data/privacy-policy-data-ar";
import { privacyPolicyContentEn } from "./data/privacy-policy-data-en";
import { termsAndConditionsContentEn } from "./data/terms-and-conditions-en";
import { termsAndConditionsContentAr } from "./data/terms-and-conditions-ar";

// Check localStorage for location (can only run on client)
let defaultLang = "en";
if (typeof window !== "undefined") {
  const location = localStorage.getItem("country");
  if (location === "KSA") {
    defaultLang = "ar";
  }
}

i18n.use(initReactI18next).init({
  resources: {
    en: {
      portfolio: projectHeading,
      blogs: {
        blogsSlideData: blogsSlidesData,
        blogsHeadings: blogHeading,
        categoryLabels: categoryLabels,
      },
      testimonials: {
        testimonialContent: testimonialContent,
        testimonialArray: testimonials,
      },
      developmentServicesSectionData: {
        developmentServicesContent: DevelopmentServicesContent,
        developmentServicesTabs: DevelopmentServicesData,
      },
      engagementModelContent: engagementModelContent,
      industryTabsSection: WebServicesIndustryTabsData,
      webAppDevelopmentPage: {
        webAppDevelopmentPageBanner: bannerContent,
        webDevPageKeyFeature: TypesOfBuildData,
        webDevWhoWeServeSection: WhoWeServeData,
        webDevPageWhyChoseBitsclan: WhyChooseBitsclanData,
        webDevPageHighValuesData: WebServicesHighvaluesData,
        webDevPageFaqs: WebServicesFaqData,
        webDevPageIndustriesHeading: webDevPageIndustriesSection,
        webDevPageCoverTheStack: CoverTheStack,
        webDevPageRoadMap: WebAppservicesRoadMap,
      },
      industries: {
        tabData: tabData,
        sliderData: slidesData,
        pioneerChangeSectionData: pioneerChangeSectionContent,
        bannerContent: BannerDataEn,
        hireContactIndustriesSection: hireContactIndustriesSectionContentEn,
        staticHeading: staticHeading,
        newIndustriesSection: industriesContent,
      },
      lifeAtBitsclan: lifeAtBitsclanData,
      customDevelopmentPage: {
        customDevPageBanner: customDevPageBannerData,
        customDevPageDevelopmentSerivces: CustomDevelopmentPageServicesData,
        customDevPageTypesOfBuild: CustomDevPageTypesOfBuildData,
        customDevPageWhoWeServeSection: CustomDevPageWhoWeServeData,
        customDevPageWhyChoseUsSection: CustomDevPageWhyChooseBitsclanData,
        customDevPageHighValueSection: customDevPageHighvaluesData,
        customDevPageRoadMapSection: customDevelopmentPageRoadMapData,
        customDevPageCoverTheStack: customDevPageCoverTheStack,
        customDevPageIndustryHeading: CustomDevelopmentIndustriesHeading,
        customDevPageFaqSection: CustomDevPageFaqData,
      },
      devOpsPage: {
        devOpsPageBanner: DevOpsBannerContent,
        devOpsPageServices: devOpsServices,
        devOpsPageProcessSteps: devOpsProcessStepsData,
        devOpsHireUsSection: devOpsPageHireUsData,
        devOpsSolutionCardSection: devOpsSolutionsData,
        devOpsPageRoadMap: devOpsRoadMapContent,
        devOpsPageCoverTheStack: devOpsCoverTheStack,
        devOpsPageWhyChoseUs: WhyChoseUsData,
        devOpsPageFaqS: DevOpsFaqData,
        devOpsPagePioneerHeading: PionerChangeHeadings,
      },
      dataAndAnylyticsPage: {
        dataAnylyticsBanner: DataAnalyticsBannerContent,
        dataAndAnylyticsServices: DataAndAnalyticsServicesData,
        dataAndAnylyticsTypeOfBuild: DataAnalyticsTypesOfBuildSection,
        dataAndAnylyticsWhoWeServe: AnalyticsWhoWeServeData,
        dataAndAnylyticsWhyChoseUs: AnalyticsWhyChooseBitsclanData,
        dataAndAnylyticsHighValueFeatures: AnalyticsHighvaluesData,
        dataAnalyticsCoverTheStackSection: dataAnalyticsCoverTheStackData,
        dataAnalyticsIndustriesHeading: industriesHeading,
        dataAnalyticsfaqSection: faqData,
      },
      roadMapCommonContent: roadMapCommonData,
      analyticsSolutionContent: analyticsData,
      engagementModelPage: engagmentModelPageData,
      engagementModelBannerContent: EngagementModelPageBannerDataEn,
      headerMegaMenu: megaMenuContent,
      footer: footerContent,
      contactSection: contactSectionComponent,
      hireRubyAndRailsPage: {
        solutionsDataContent: solutionsData,
        faqDataContent: hirefaqData,
        mainBannerImgContent: mainBannerImg,
        servicesDataContent: servicesData,
        stepsContent: steps,
        factsContent: facts,
        hiringDetailsContent: hiringDetails,
        tabsContent: tabs,
        tabItemsContent: tabItems,
        techCombinationsContent: techCombinations,
        schemaDataContent: schemaData,
        hireRubyAndRailsPageContentData: hireRubyAndRailsPageContent,
      },
      aiDevelopmentPageContent: {
        aiDevBanner: aiDevBannerContent,
        aiPowerSection: aiPowerSectionContent,
        aiDevelopmentServices: AiDevelopmentServicesData,
        notOnlyAiCompanySection: aiDevelopmentBoxContent,
        industriesSectionContent: IndustriesSectionContent,
        FutureSoltionContent: AIDevPageSolutionsSection,
        aiDevWhyUsContent: AIDevWhyUsContent,
        aiDevRoadMapSection: AIDevRoadmapContent,
        aiDevCoverTheStackSection: aiDevCoverTheStack,
        aiDevFaqSection: AiDevPageFaqData,
      },
      mobileAppDevelopmentPage: {
        mobileAppBanner: mobileAppPageBanner,
        mobileAppServicesSection: mobileAppDevelopmetServices,
        mobileAppTypeOfBuildSection: mobileAppTypesOfBuildData,
        mobileAppWhoWeServeSection: mobileAppWhoWeServeData,
        mobileAppWhyChooseUsSection: mobileAppWhyChoseUs,
        mobileAppHighValueSection: mobileAppHighvaluesData,
        mobileAppRoadMapSection: mobileAppRoadMapHeadings,
        mobileAppCoverTheStack: mobileAppCoverTheStack,
        mobileAppIndustriesHeading: mobileAppIndustriesHeading,
        mobileAppFaqSection: frequentlyAskedQuestionData,
      },
      softwareQualityAssurencePage: {
        pageBanner: sqaPageBanner,
        pageServicesData: SaqDevelopmentServicesData,
        pageTypesOfBuildData: sqaTypesOfBuildData,
        pageWhoWeServeCards: sqaWhoWeServeData,
        pageChooseUs: sqaWhyChooseBitsclanData,
        pageHighValueCards: sqaHighvaluesData,
        pageRoadMap: sqaRoadMapData,
        pageCoverTheStack: sqaCoverTheStack,
        pageIndustriesHeading: sqaIndustriesHeading,
        pageFaqData: sqaFaqData,
      },
      BlockChainAnalyticsPage: {
        pageBanner: BlockchainBannerContent,
        pageServicesData: BlockchainDevelopmentServicesData,
        pageProcessStepsData: BlockchainProcessStepsData,
        pageWhoServeData: BlockchainWhoWeServeData,
        pageWhyChooseUsData: BlockchainWhyChooseBitsclanData,
        pageHighValueData: BlockchainHighvaluesData,
        pageRoadMapData: BlockchainRoadMapData,
        pageCoverTheStack: BlockchainCoverTheStack,
        pageIndustriesHeading: BlockchainIndustriesHeading,
        pageFaq: BlockchainFaqData,
      },
      headerMegaMenu: megaMenuContent,
      ksaHome: KsaHomeData,
      hireDjangoPage: hireDjangoPageData,
      cybersecurityPage: {
        pageBanner: CybersecurityBannerContent,
        pageServicesData: cyberSecurityDevelopmentServicesData,
        pageAccordianData: cyberSecurityTypesOfBuildData,
        pageWhoServeData: cyberSecurityWhoWeServeData,
        pageWhyChooseUsData: cyberSecurityWhyChooseBitsclanData,
        pageHighValueData: cyberSecurityHighvaluesData,
        pageRoadMapData: CybersecurityRoadmapData,
        pageCoverTheStack: cyberSecurityCoverTheStack,
        pageIndustriesHeading: cyberSecurityIndustriesHeading,
        pageFaqData: cyberSecurityFaqData,
      },
      hireAngularPage: {
        bannerData: HireAngularBannerDataEn,
        servicesData: HireAngularServicesDataEn,
        solutionData: HireAngularSolutionsDataEn,
        combinationData: techCombinationsEn,
        pageStepsData: HireAngularStepsEn,
        coverTheStackData: hireAngularCoverTheStackEn,
        factsData: HireAngularFactsDataEn,
        appIdeaData: hireAppContentEn,
        faqData: HireAngularFaqDataEn,
        hirePageEngagmentModelSection: hireAngularEnagementModelEn,
        mainBannerImgData: mainBannerImgAngular,
      },
      hireReactPage: {
        bannerData: hireReactBannerContentEn,
        servicesData: hireReactServicesDataEn,
        solutionData: hireReactSolutionsDataEn, // This was duplicated, removed from the top-level
        combinationData: hireReactCombinationsEn, // Added from the second import
        stepsData: hireReactStepsEn, // Added from the second import
        coverTheStackData: hireReactCoverTheStackEn, // Added from the second import
        factsData: hireReactExpertFactsEn, // Added from the second import
        appIdeaData: hireAppIdesContentEn, // Added from the second import
        pageEngagmentModels: hireReactPageEngagementModelsEn, // Added from the second import
        faqData: reactFaqContentEn, // Added from the second import
        mainBannerImgData: mainBannerImgReact,
      },
      hireGoLangPageContent: hireGoLangContent,
      hireFlutterPage: hireFlutterPageContent,
      hireMernStackPage: hireMernStackPageContent,
      hireJavascriptPage: hireJavascriptPageContent,
      hireAndroidPage: hireAndroidDeveloper,
      hireNodePage: hireNodePageContent,
      hirePythonPage: {
        bannerContent: hirePythonBannerContentEn,
        servicesData: hirePythonExpertiseEn,
        developmentPerformaceData: hirePythonPerformanceEn,
        combinationData: hirePythonCombinationsEn,
        stepsData: hirePythonStepsEn,
        coverTheStackData: coverTheStackPythonEn,
        factsData: hirePythonFactsDataEn,
        appIdeaData: factIdeaEn,
        engagementModelContent: hirePythonPageContentEn,
        faqsSection: hirePythonFaqDataEn,
        mainBannerImgData: mainBannerImgPython,
      },
      modalsContent: {
        privacyPolicyModal: privacyPolicyObj,
        cookiesModal: cookiesObj,
      },
      portfolioPage: portfolioPageData,
      caseStudiesPage: {
        caseStudyBanner: caseStudyBannerEn,
        caseStudies: caseStudiesContentEn,
      },
      aiSectionData: { aiSection: aiContactDataArabic },
      metaTitles: metaTitlesEn,
      privacyPolicyPage: privacyPolicyContentEn,
      termsAndConditionsPage: termsAndConditionsContentEn,
    },
    ar: {
      portfolio: projectHeadingAbabic,
      blogs: {
        blogsSlideData: blogsSlidesDataArabic,
        blogsHeadings: blogHeadingArabic,
        categoryLabels: categoryLabelsArabic,
      },
      testimonials: {
        testimonialContent: testimonialContentArabic,
        testimonialArray: testimonialsArabic,
      },
      developmentServicesSectionData: {
        developmentServicesContent: DevelopmentServicesContentArabic,
        developmentServicesTabs: DevelopmentServicesDataArabic,
      },
      engagementModelContent: engagementModelContentArabic,
      engagementModelBannerContent: EngagementModelPageBannerDataAr,
      industryTabsSection: WebServicesIndustryTabsDataArabic,
      webAppDevelopmentPage: {
        webAppDevelopmentPageBanner: bannerContentArabic,
        webDevPageKeyFeature: TypesOfBuildDataArabic,
        webDevWhoWeServeSection: WhoWeServeDataArabic,
        webDevPageWhyChoseBitsclan: WhyChooseBitsclanDataArabic,
        webDevPageHighValuesData: WebServicesHighvaluesDataArabic,
        webDevPageFaqs: WebServicesFaqDataArabic,
        webDevPageCoverTheStack: CoverTheStackArabic,
        webDevPageIndustriesHeading: webDevPageIndustriesSectionArabic,
        webDevPageRoadMap: WebAppservicesRoadMapArabic,
      },
      industries: {
        tabData: tabDataArabic,
        sliderData: slidesDataArabic,
        pioneerChangeSectionData: pioneerChangeSectionContentArabic,
        bannerContent: similerBannerDataAr,
        hireContactIndustriesSection: hireContactIndustriesSectionContentAr,
        staticHeading: staticHeadingArabic,
        newIndustriesSection: industriesContentArabic,
      },
      lifeAtBitsclan: lifeAtBitsclanArabicData,
      customDevelopmentPage: {
        customDevPageBanner: customDevPageBannerDataArabic,
        customDevPageDevelopmentSerivces:
          CustomDevelopmentPageServicesDataArabic,
        customDevPageTypesOfBuild: CustomDevPageTypesOfBuildDataArabic,
        customDevPageWhoWeServeSection: CustomDevPageWhoWeServeDataArabic,
        customDevPageWhyChoseUsSection:
          CustomDevPageWhyChooseBitsclanDataArabic,
        customDevPageHighValueSection: customDevPageHighvaluesDataArabic,
        customDevPageRoadMapSection: customDevelopmentPageRoadMapDataArabic,
        customDevPageCoverTheStack: customDevPageCoverTheStackArabic,
        customDevPageIndustryHeading: CustomDevelopmentIndustriesHeadingArabic,
        customDevPageFaqSection: CustomDevPageFaqDataArabic,
      },
      devOpsPage: {
        devOpsPageBanner: DevOpsBannerContentArabic,
        devOpsPageServices: devOpsServicesArabic,
        devOpsPageProcessSteps: devOpsProcessStepsDataArabic,
        devOpsHireUsSection: devOpsPageHireUsDataArabic,
        devOpsSolutionCardSection: devOpsSolutionsDataArabic,
        devOpsPageRoadMap: devOpsRoadMapContentArabic,
        devOpsPageCoverTheStack: devOpsCoverTheStackArabic,
        devOpsPageWhyChoseUs: WhyChoseUsDataArabic,
        devOpsPageFaqS: DevOpsFaqDataArabic,
        devOpsPagePioneerHeading: PionerChangeHeadingsArabic,
      },
      dataAndAnylyticsPage: {
        dataAnylyticsBanner: DataAnalyticsBannerContentArabic,
        dataAndAnylyticsServices: DataAndAnalyticsServicesDataArabic,
        dataAndAnylyticsTypeOfBuild: DataAnalyticsTypesOfBuildSectionArabic,
        dataAndAnylyticsWhoWeServe: AnalyticsWhoWeServeDataArabic,
        dataAndAnylyticsWhyChoseUs: AnalyticsWhyChooseBitsclanDataArabic,
        dataAndAnylyticsHighValueFeatures: AnalyticsHighvaluesDataArabic,
        dataAnalyticsCoverTheStackSection: dataAnalyticsCoverTheStackDataArabic,
        dataAnalyticsIndustriesHeading: industriesHeadingArabic,
        dataAnalyticsfaqSection: faqDataArabic,
      },
      roadMapCommonContent: roadMapCommonDataArabic,
      analyticsSolutionContent: analyticsDataArabic,
      engagementModelPage: engagmentModelPageDataArabic,
      headerMegaMenu: megaMenuContentArabic,
      footer: footerContentArabic,
      contactSection: contactSectionComponentArabic,
      hireRubyAndRailsPage: {
        solutionsDataContent: solutionsDataArabic,
        faqDataContent: hireFaqDataArabic,
        mainBannerImgContent: mainBannerImgArabic,
        servicesDataContent: servicesDataArabic,
        stepsContent: stepsArabic,
        factsContent: factsArabic,
        hiringDetailsContent: hiringDetailsArabic,
        tabsContent: tabsArabic,
        tabItemsContent: tabItemsArabic,
        techCombinationsContent: techCombinationsArabic,
        schemaDataContent: schemaDataArabic,
        hireRubyAndRailsPageContentData: hireRubyAndRailsPageContentArabic,
      },
      aiDevelopmentPageContent: {
        aiDevBanner: aiDevBannerContentArabic,
        aiPowerSection: aiPowerSectionContentArabic,
        aiDevelopmentServices: AiDevelopmentServicesDataArabic,
        notOnlyAiCompanySection: aiDevelopmentBoxContentArabic,
        industriesSectionContent: IndustriesSectionContentArabic,
        FutureSoltionContent: AIDevPageSolutionsSectionArabic,
        aiDevWhyUsContent: AIDevWhyUsContentArabic,
        aiDevRoadMapSection: AIDevRoadmapContentArabic,
        aiDevCoverTheStackSection: aiDevCoverTheStackArabic,
        aiDevFaqSection: AiDevPageFaqDataArabic,
      },
      mobileAppDevelopmentPage: {
        mobileAppBanner: mobileAppPageBannerArabic,
        mobileAppServicesSection: mobileAppDevelopmetServicesArabic,
        mobileAppTypeOfBuildSection: mobileAppTypesOfBuildDataArabic,
        mobileAppWhoWeServeSection: mobileAppWhoWeServeDataArabic,
        mobileAppWhyChooseUsSection: mobileAppWhyChoseUsArabic,
        mobileAppHighValueSection: mobileAppHighvaluesDataArabic,
        mobileAppRoadMapSection: mobileAppRoadMapHeadingsArabic,
        mobileAppCoverTheStack: mobileAppCoverTheStackArabic,
        mobileAppIndustriesHeading: mobileAppIndustriesHeadingArabic,
        mobileAppFaqSection: frequentlyAskedQuestionDataArabic,
      },
      softwareQualityAssurencePage: {
        pageBanner: sqaPageBannerArabic,
        pageServicesData: SaqDevelopmentServicesDataArabic,
        pageTypesOfBuildData: sqaTypesOfBuildDataArabic,
        pageWhoWeServeCards: sqaWhoWeServeDataArabic,
        pageChooseUs: sqaWhyChooseBitsclanDataArabic,
        pageHighValueCards: sqaHighvaluesDataArabic,
        pageRoadMap: sqaRoadMapDataArabic,
        pageCoverTheStack: sqaCoverTheStackArabic,
        pageIndustriesHeading: sqaIndustriesHeadingArabic,
        pageFaqData: sqaFaqDataArabic,
      },
      BlockChainAnalyticsPage: {
        pageBanner: BlockchainBannerContentArabic,
        pageServicesData: BlockchainDevelopmentServicesDataArabic,
        pageProcessStepsData: BlockchainProcessStepsDataArabic,
        pageWhoServeData: BlockchainWhoWeServeDataArabic,
        pageWhyChooseUsData: BlockchainWhyChooseBitsclanDataArabic,
        pageHighValueData: BlockchainHighvaluesDataArabic,
        pageRoadMapData: BlockchainRoadMapDataArabic,
        pageCoverTheStack: BlockchainCoverTheStackArabic,
        pageIndustriesHeading: BlockchainIndustriesHeadingArabic,
        pageFaq: BlockchainFaqDataArabic,
      },
      headerMegaMenu: megaMenuContentArabic,
      ksaHome: KsaHomeDataArabic,
      hireDjangoPage: hireDjangoPageDataArabic,
      cybersecurityPage: {
        pageBanner: CybersecurityBannerContentArabic,
        pageServicesData: cyberSecurityDevelopmentServicesDataArabic,
        pageAccordianData: cyberSecurityTypesOfBuildDataArabic,
        pageWhoServeData: cyberSecurityWhoWeServeDataArabic,
        pageWhyChooseUsData: cyberSecurityWhyChooseBitsclanDataArabic,
        pageHighValueData: cyberSecurityHighvaluesDataArabic,
        pageRoadMapData: CybersecurityRoadmapDataArabic,
        pageCoverTheStack: cyberSecurityCoverTheStackArabic,
        pageIndustriesHeading: cyberSecurityIndustriesHeadingArabic,
        pageFaqData: cyberSecurityFaqDataArabic,
      },
      hireAngularPage: {
        bannerData: HireAngularBannerDataAr,
        servicesData: HireAngularServicesDataAr,
        solutionData: HireAngularSolutionsDataAr,
        combinationData: techCombinationsAr,
        pageStepsData: HireAngularStepsAr,
        coverTheStackData: hireAngularCoverTheStackAr,
        factsData: HireAngularFactsDataAr,
        appIdeaData: hireAppContentAr,
        faqData: HireAngularFaqDataAr,
        hirePageEngagmentModelSection: hireAngularEnagementModelAr,
        mainBannerImgData: mainBannerImgAngularArabic,
      },
      hireReactPage: {
        bannerData: hireReactBannerContentAr,
        servicesData: hireReactServicesDataAr,
        solutionData: hireReactSolutionsDataAr,
        combinationData: hireReactCombinationsAr,
        stepsData: hireReactStepsAr,
        coverTheStackData: hireReactCoverTheStackAr,
        factsData: hireReactExpertFactsAr,
        appIdeaData: hireAppIdesContentAr,
        pageEngagmentModels: hireReactPageEngagementModelsAr,
        faqData: reactFaqContentAr,
        mainBannerImgData: mainBannerImgReactAr,
      },
      hireGoLangPageContent: hireGoLangContentArabic,
      hireFlutterPage: hireFlutterPageContentArabic,
      hireMernStackPage: hireMernStackPageContentArabic,
      hireJavascriptPage: hireJavascriptPageContentArabic,
      hireAndroidPage: hireAndroidPageContentArabic,
      hireNodePage: hireNodePageContentArabic,
      hirePythonPage: {
        bannerContent: hirePythonBannerContentAr,
        servicesData: hirePythonExpertiseAr,
        developmentPerformaceData: hirePythonPerformanceAr,
        combinationData: hirePythonCombinationsAr,
        stepsData: hirePythonStepsAr,
        coverTheStackData: coverTheStackPythonAr,
        factsData: hirePythonFactsDataAr,
        appIdeaData: factIdeaAr,
        engagementModelContent: hirePythonPageContentAr,
        faqsSection: hirePythonFaqDataAr,
        mainBannerImgData: mainBannerImgPythonArabic,
      },
      modalsContent: {
        privacyPolicyModal: privacyPolicyObjArabic,
        cookiesModal: cookiesObjArabic,
      },
      portfolioPage: portfolioPageDataArabic,
      caseStudiesPage: {
        caseStudyBanner: caseStudyBannerAr,
        caseStudies: caseStudiesContentAr,
      },
      aiSectionData: { aiSection: aiContactDataArabic },
      metaTitles: metaTitlesAr,
      privacyPolicyPage: privacyPolicyContentAr,
      termsAndConditionsPage: termsAndConditionsContentAr,
    },
  },
  lng: defaultLang, // dynamically set based on localStorage
  fallbackLng: "en",
  ns: [
    "portfolio",
    "blogs",
    "testimonials",
    "developmentServicesSectionData",
    "webAppDevelopmentPage",
    "engagementModelContent",
    "industries",
    "lifeAtBitsclan",
    "customDevelopmentPage",
    "devOpsPage",
    "dataAndAnylyticsPage",
    "analyticsSolutionContent",
    "engagementModelPage",
    "headerMegaMenu",
    "footer",
    "industryTabsSection",
    "roadMapCommonContent",
    "aiDevelopmentPageContent",
    "mobileAppDevelopmentPage",
    "softwareQualityAssurencePage",
    "BlockChainAnalyticsPage",
    "contactSection",
    "hireRubyAndRailsPage",
    "engagementModelPage",
    "headerMegaMenu",
    "ksaHome",
    "engagementModelBannerContent",
    "hireAngularPage",
    "hireReactPage",
    "hireDjangoPage",
    "hireGoLangPageContent",
    "hireFlutterPage",
    "hireJavascriptPage",
    "hireAndroidPage",
    "hireNodePage",
    "hirePythonPage",
    "portfolioPage",
    "modalsContent",
    "caseStudiesPage",
    "aiSectionData",
  ], // namespaces (your file names)
  interpolation: { escapeValue: false },
});

export default i18n;
